import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

export const withPropFilter = (WrappedComponent, propFilter) => {
  const Wrapper = (props) => {
    const filteredProps = propFilter(props);

    return <WrappedComponent {...filteredProps} />;
  };

  Wrapper.displayName = `withPropFilter(
    ${getDisplayName(WrappedComponent)}
  )`;

  hoistNonReactStatics(Wrapper, WrappedComponent);

  Wrapper.propTypes = {
    props: PropTypes.shape({}),
  };

  Wrapper.defaultProps = {
    props: PropTypes.undefined,
  };

  return Wrapper;
};
